module.exports = __webpack_public_path__ + "img/嘉兴市.376516a3.png";